export default __webpack_public_path__ + "static/media/platinum.9a2aa6b8.png";